<app-select-input
        *ngIf="businesses$ | async as businesses; else spinner"
        class="block business-selector"
        [options]="businesses"
        optionLabelKey="name"
        optionValueKey="id"
        [currentValue]="selectedBusinesses"
        [showSearch]="true"
        [multiple]="multiple"
        [label]="label"
        (valueChange)="changeValue($event)"
></app-select-input>

<ng-template #spinner>
	<mat-spinner [diameter]="20"></mat-spinner>
</ng-template>
